// extracted by mini-css-extract-plugin
module.exports = {"image":"_4237cfa","centerImage":"_41a426a"};